import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-offers-page',
  templateUrl: './offers-page.component.html',
  styleUrl: './offers-page.component.scss',
})
export class OffersPageComponent implements OnInit, OnDestroy {
  constructor(private navigationService: NavigationService) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
